const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "";

const safeBase = (base) => String(base || "").replace(/\/+$/, "");

function getAuthToken() {
  return (
    localStorage.getItem("superadminToken") ||
    localStorage.getItem("clientAuthToken") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    ""
  );
}

async function requestJson(path, { method = "GET", body, signal } = {}) {
  const token = getAuthToken();
  const response = await fetch(`${safeBase(API_BASE_URL)}${path}`, {
    method,
    signal,
    cache: "no-store",
    credentials: "include",
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(
      payload?.message || payload?.error || `Request failed (${response.status})`
    );
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export function fetchAudienceIntelligenceResolution(
  { advertiserId, platform, campaignId, campaignName, startDate, endDate },
  { signal } = {}
) {
  if (!advertiserId || !platform) return Promise.resolve(null);

  const query = new URLSearchParams();
  query.set("platform", platform);
  query.set("fallback", "1");
  if (campaignId) query.set("campaignId", String(campaignId));
  if (campaignName) query.set("campaignName", String(campaignName));
  if (startDate) query.set("startDate", String(startDate));
  if (endDate) query.set("endDate", String(endDate));

  return requestJson(
    `/api/audience-intelligence/${encodeURIComponent(advertiserId)}?${query.toString()}`,
    { signal }
  );
}

export function listAudienceIntelligenceSnapshots(advertiserId, { signal } = {}) {
  return requestJson(
    `/api/audience-intelligence/${encodeURIComponent(advertiserId)}?includeAll=1`,
    { signal }
  );
}

export function createAudienceIntelligenceSnapshot(payload, { signal } = {}) {
  return requestJson("/api/audience-intelligence", {
    method: "POST",
    body: payload,
    signal,
  });
}

export function updateAudienceIntelligenceSnapshot(id, payload, { signal } = {}) {
  return requestJson(`/api/audience-intelligence/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: payload,
    signal,
  });
}

export function deleteAudienceIntelligenceSnapshot(id, { signal } = {}) {
  return requestJson(`/api/audience-intelligence/${encodeURIComponent(id)}`, {
    method: "DELETE",
    signal,
  });
}
